(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var schemata = require('schemata')
  , itineraryContactSchema = require('./contact-schema')
  , itineraryVenueSchema = require('./venue-schema')
  , flightSchema = require('./flight-schema')
  , trainSchema = require('./train-schema')
  , groundTransportationSchema = require('./ground-transportation-schema')
  , accommodationSchema = require('./accommodation-schema')
const required = require('@clocklimited/validity-required')

module.exports = function () {

  function dynamicContentSchema (obj) {
    try {
      var type = obj.type
        , types =
          { contacts: schemata.Array(itineraryContactSchema())
          , contact: itineraryContactSchema()
          , venue: itineraryVenueSchema()
          , flight: flightSchema()
          , train: trainSchema()
          , ground: groundTransportationSchema()
          , accommodation: accommodationSchema()
          }

      return types[type]

    } catch (e) {
      return {}
    }
  }

  return schemata(
    { type:
      { type: String
      , validators:
        { all: [ required ]
        }
      }
    , content:
      { type: dynamicContentSchema
      , validators:
        { all: [ required ]
        }
      }
    }
  )
}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/components/service/itinerary/item-schema.js","/components/service/itinerary")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,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